import { createFileRoute } from '@tanstack/react-router'

import { AiRatePage } from '#/modules/ai-costs'

export const Route = createFileRoute('/_shell/ai-rates/$rateId')({
  component: function AiRateRoute() {
    const { rateId } = Route.useParams()
    return <AiRatePage rateId={rateId} />
  },
})
